import { render, staticRenderFns } from "./CardButton.vue?vue&type=template&id=53d5a5b6&"
import script from "./CardButton.vue?vue&type=script&lang=js&"
export * from "./CardButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VImg})
